export default function ReportIcon() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 159 147"
      fill="none"
      style={{ stroke: "black", strokeWidth: "8px" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2230_7392)">
        <path
          d="M20.83 78.73C15.3089 78.7353 10.0153 80.9302 6.11034 84.8333C2.20539 88.7363 0.0079415 94.0289 0 99.55V146.4H41.65V99.55C41.6421 94.0306 39.446 88.7396 35.5432 84.8368C31.6404 80.934 26.3494 78.7379 20.83 78.73ZM35.14 139.89H6.52V99.55C6.61859 95.8215 8.16897 92.2789 10.8409 89.6767C13.5129 87.0744 17.0953 85.6182 20.825 85.6182C24.5547 85.6182 28.1371 87.0744 30.8091 89.6767C33.481 92.2789 35.0314 95.8215 35.13 99.55L35.14 139.89Z"
          fill="#129219"
        />
        <path
          d="M79.3801 42.9399C73.859 42.9479 68.5664 45.1453 64.6633 49.0503C60.7603 52.9552 58.5653 58.2488 58.5601 63.7699V146.41H100.21V63.7699C100.205 58.2471 98.0085 52.952 94.1032 49.0468C90.198 45.1415 84.9029 42.9452 79.3801 42.9399ZM93.6901 139.89H65.0801V63.7699C65.0295 61.8596 65.3622 59.9584 66.0584 58.1787C66.7545 56.3989 67.8002 54.7767 69.1335 53.4076C70.4668 52.0386 72.0609 50.9504 73.8216 50.2075C75.5823 49.4645 77.474 49.0817 79.3851 49.0817C81.2961 49.0817 83.1878 49.4645 84.9485 50.2075C86.7092 50.9504 88.3033 52.0386 89.6366 53.4076C90.97 54.7767 92.0156 56.3989 92.7117 58.1787C93.4079 59.9584 93.7406 61.8596 93.6901 63.7699V139.89Z"
          fill="#129219"
        />
        <path
          d="M137.94 0C132.417 0.00529515 127.122 2.20158 123.217 6.10681C119.312 10.012 117.115 15.3072 117.11 20.83V146.41H158.76V20.83C158.755 15.3089 156.56 10.0153 152.657 6.11034C148.754 2.20539 143.461 0.0079415 137.94 0V0ZM152.25 139.89H123.63V20.83C123.58 18.9196 123.912 17.0185 124.608 15.2387C125.305 13.459 126.35 11.8367 127.684 10.4677C129.017 9.09862 130.611 8.01049 132.372 7.26751C134.132 6.52453 136.024 6.14175 137.935 6.14175C139.846 6.14175 141.738 6.52453 143.499 7.26751C145.259 8.01049 146.853 9.09862 148.187 10.4677C149.52 11.8367 150.566 13.459 151.262 15.2387C151.958 17.0185 152.291 18.9196 152.24 20.83L152.25 139.89Z"
          fill="#129219"
        />
      </g>
      <defs>
        <clipPath id="clip0_2230_7392">
          <rect width="158.77" height="146.41" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
